/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef ,useEffect} from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/RubberTube/tubeYellow.glb')
  const { actions } = useAnimations(animations, group)
  // console.log(actions)
  // useEffect(() => {
  //   actions.Animation9.play();
  //   actions.Animation9.repetitions = 1;
  //   actions.Animation9.clampWhenFinished = true;
  // }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <mesh name="yellow" geometry={nodes.yellow.geometry} material={materials['材質.001']} />
      </group>
    </group>
  )
}

useGLTF.preload('/RubberTube/tubeYellow.glb')
